import React, { useEffect, useState } from 'react'
import { Column } from 'react-table';
import LineChart from '../../components/chartTypes/lineChart';
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter';
import { generatePrincipalDPDEmi } from '../../services/delinquencyReports';
import VerticalTable from '../../components/verticalTable';
import { emiReportDate, sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';
import { useTranslation } from 'react-i18next';
import { generateDeliquencyLinechartEMI } from '../../services/summaryReportsEMI';

const DeliquencyRatesEMI = () => {
  const { t } = useTranslation();

  
  

  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => ({
          periodWithOutDay: ["month"],
          fromDate: [sixMonthsAgoFormatted],
          toDate: [emiReportDate]
          }));

  const filters = [
      { key: "state", type: "select", label: t("filters.state") },
      // { key: "territory", type: "select", label: t("filters.territory") },
      { key: "cluster", type: "select", label: t("filters.cluster") },
      { key: "branch", type: "select", label: t("filters.branch") },
      { key: "periodWithOutDay", type: "singleSelect", label: t("filters.period") },
      { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
      { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: emiReportDate },
    ];

  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  // const [principalDPDEwi, setPrincipalDPDEwi] = useState<any[]>([]);
  const [principalDPDEwi, setPrincipalDPDEwi] = useState<{ headers: string[]; data: { category: string; values: string[] }[] }>({
          headers: [],
          data: [],
      });
  const [loading, setLoading] = useState<boolean>(true);
  const [portfolioMovement, setPortfolioMovement] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [portfolioMovementLoading, setPortfolioMovementLoading] = useState<boolean>(true);

  const handleFilterChange = (updatedValues: Record<string, string[]>) => {
      setSelectedFilters(updatedValues);
      };

  const handleCancelClick = () => {
      setSelectedFilters({
        periodWithOutDay: ["month"],
        fromDate: [sixMonthsAgoFormatted],
        toDate: [emiReportDate]
      })
      setApplyFilter(!applyFilter)
      }

  const getGeneratePrincipalDPDEmi = async () => {
      setLoading(true);
      try {
        const response = await generatePrincipalDPDEmi(selectedFilters); // Call the API function
        // const data: Order[] = response.data.map((item: any) => {
        //   const dpdValues = item.dpd_buckets.map((bucket: any) => parseFloat(bucket.percentage));
        //   const total = dpdValues.reduce((acc: any, val: any) => acc + val, 0).toFixed(2) + "%";
        
        //   return {
        //     month: item.period,
        //     dpd1: dpdValues[0] + "%",
        //     dpd2: dpdValues[1] + "%",
        //     dpd3: dpdValues[2] + "%",
        //     dpd4: dpdValues[3] + "%",
        //     dpd5: dpdValues[4] + "%",
        //     dpd6: dpdValues[5] + "%",
        //     dpd7: dpdValues[6] + "%",
        //     dpd8: dpdValues[7] + "%",
        //     dpd9: total,
        //   };
        // });

        const apiData: any[] = response.data; // Ensure it's treated as an array of objects

        // Extract unique bucket names from the first period entry
        const bucketCategories = apiData[0]?.dpd_buckets.map((bucket: { bucket_name?: string; slab_name?: string }) => ({
            category: bucket.bucket_name || bucket.slab_name || "Unknown", // Handle different key names safely
        })) || [];

        // Transform the API response into table format
        const headers: string[] = ["DPD Bucket", ...apiData.map((item: { period: string }) => item.period)];

        const transformedData = bucketCategories.map(({ category }: { category: string }, index: number) => ({
            category,
            values: apiData.map((item: { dpd_buckets: { percentage?: string }[] }) => item.dpd_buckets[index]?.percentage || "0"),
        }));

        // Update state with transformed data
        setPrincipalDPDEwi({ headers, data: transformedData });

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

  const generatePortfolioNetMovement= async () => {
    setPortfolioMovementLoading(true);
    try {
      const response = await generateDeliquencyLinechartEMI(selectedFilters); // Call the API function
      setPortfolioMovement(response.data); // Update state with user data
    } catch (err) {
      setError("Failed to fetch users");
      console.error(err);
    } finally {
      setPortfolioMovementLoading(false);
    }
  };

  useEffect(() => {
    getGeneratePrincipalDPDEmi();
    generatePortfolioNetMovement();
  }, [applyFilter]);

  return (
    <div>
    {/* Page Content */}
    <div className="page-content">
      {/* Dynamic Grey Header */}
      <div className="header">
      {t('EMIReportsFolder.deliquencyEMI.pageTitle')}
      </div>

      {/* Main Content */}

        <div className="content px-3">
            <MultiSelectCheckboxGroup 
            filters={filters} 
            selectedValues={selectedFilters} 
            onChange={handleFilterChange} 
            isLoading={[loading]}
            buttons={[
              { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter) },
              { label: t("buttons.cancel"), onClick: handleCancelClick },
              { label: t("buttons.download"), onClick: () => alert("Download triggered") },
            ]}
            />
        </div>

       
      {/* PE O/S by DPD EWI*/}
        <div className="p-3">
          <div style={{"width": "100%", "overflow": "scroll"}}>
          {/* <Table 
              columns={columns} 
              data={principalDPDEwi} 
              tableHead="PE O/S by DPD EWI"
              type="1"
              loading={loading}
          /> */}
           <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('EMIReportsFolder.deliquencyEMI.PE O/S by DPD EMI')}</h2>
           <VerticalTable headers={principalDPDEwi.headers} data={principalDPDEwi.data} loading={loading} />
          </div>
        </div>


        <div className="mt-1 p-2">
        <LineChart 
            title={t('EMIReportsFolder.deliquencyEMI.title')}
            labels={portfolioMovement.map(item => item.period)}
            // dataSets={[
            //     { label: "Kerala", data: [30000, 20000, 25000, 30000, 35000, 20000, 45000, 50000, 55000, 60000, 40000, 70000], borderColor: "#70e000" },
            //     { label: "Tamil Nadu", data: [40000, 25000, 30000, 35000, 30000, 45000, 50000, 55000, 60000, 65000, 70000, 60000], borderColor: "#003f88" },
            //     { label: "Karnataka", data: [10000, 15000, 20000, 25000, 40000, 50000, 40000, 45000, 50000, 25000, 60000, 35000], borderColor: "#FF5733" },                  
            // ]}
            dataSets = {[
              { label: "%30+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%30+ DPD")?.percentage || 0), borderColor: "#70e000" },
              { label: "%60+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%60+ DPD")?.percentage || 0), borderColor: "#003f88" },
              { label: "%90+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%90")?.percentage || 0), borderColor: "#FF5733" }
            ]}
            xLabel={t('EMIReportsFolder.deliquencyEMI.xLabel')}
            yLabel={t('EMIReportsFolder.deliquencyEMI.yLabel')}
        />
        </div>

    </div>
  </div>
  )
}

export default DeliquencyRatesEMI;
